import { ITopBarMenuItem } from "components/TopBar/TopBarMenuItem";
import { createContext } from "react";

export interface ILayoutContext {
  isMobile: boolean;
  isLogged: boolean;
  setPageMenuItems: (menuItems?: ITopBarMenuItem[]) => void;
  setToolbarReadOnly: (readOnly:boolean) => void;
  pageMenuItems: ITopBarMenuItem[];
  headerHeight: number;
  startLoading: (message?: string, flg?: boolean) => void;
  finishLoading: () => void;
  disableNavDrawer?: boolean;
  setDisableNavDrawer: (value: boolean) => void;
}

export default createContext<ILayoutContext>({
  isMobile: false,
  isLogged: false,  
  setPageMenuItems: () => {},
  setToolbarReadOnly: () => {},
  pageMenuItems: [],
  headerHeight: 0,
  startLoading: () => {},
  finishLoading: () => {},
  setDisableNavDrawer: () => {},
})